import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { ApprovalType } from 'shared/domains/apollo/generated/types';
import { SendForApprovalModalWrapper } from './SendForApprovalModalWrapper';
import { useWorkflowApprovers } from '../WorkflowApproversProvider';
export function AskForApprovalButton() {
    const { selectedApprovers } = useWorkflowApprovers();
    const [dialogType, setDialogType] = useState('hide');
    const disabled = selectedApprovers.length === 0;
    const showAllDialog = () => setDialogType(ApprovalType.All);
    const showOneOfDialog = () => setDialogType(ApprovalType.OneOf);
    const hideDialog = () => setDialogType('hide');
    return (<Fragment>
      {dialogType !== 'hide' && (<SendForApprovalModalWrapper type={dialogType} approvers={selectedApprovers} onClose={hideDialog}/>)}

      <Menu.Root side="top" align="end" target={<Button $stretch size="small" appearance="primary" disabled={disabled}>
            <Trans comment="Document approval check - Ask for approval button label">Ask for approval</Trans>
          </Button>}>
        <Menu.Item onClick={showAllDialog}>
          <Menu.ItemText truncate={false} primary={t({
            comment: 'Document approval check - Ask for approval by all button label',
            message: 'By all approvers',
        })} secondary={t({
            comment: 'Document approval check - Ask for approval by all button description',
            message: 'All assigned approvers need to approve before eSigning is enabled.',
        })}/>
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item onClick={showOneOfDialog}>
          <Menu.ItemText truncate={false} primary={t({
            comment: 'Document approval check - Ask for approval by one of button label',
            message: 'By one of the approvers',
        })} secondary={t({
            comment: 'Document approval check - Ask for approval by one of button description',
            message: 'Only one of the added approvers needs to approve the document before eSigning is enabled.',
        })}/>
        </Menu.Item>
      </Menu.Root>
    </Fragment>);
}
